import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './create-sociogram-modal.module.scss'
import ButtonComponent from '@BUP/components/Generics/Button'
import ModalComponent from '@BUP/components/Generics/Modal'
import { EventsContext } from '@BUP/contexts/EventsContext'
import { CurrentSociogramContext } from '@BUP/contexts/CurrentSociogramContext'
import { useSendCreationSociogram } from '@BUP/hooks/Sociogram/useSendCreationSociogram'

const CreateSociogramModal = ({ disabled }) => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.sociogram.activeSociogramEce'
  })

  const { mutateEvents } = useContext(EventsContext)
  const { getCurrentSociogram } = useContext(CurrentSociogramContext)

  const [showCreateSociogramModal, setShowCreateSociogramModal] =
    useState(false)

  const {
    loadingResponse: loadingResponseCreationSociogram,
    confirmCreationSociogram
  } = useSendCreationSociogram()

  const handleOpenSociogramModal = () => {
    setShowCreateSociogramModal(true)
  }

  const handleCloseSociogramModal = () => {
    setShowCreateSociogramModal(false)
  }

  const handleClickCreateSociogram = async () => {
    await confirmCreationSociogram()
    const refreshActions = [mutateEvents, getCurrentSociogram]
      .filter(Boolean)
      .map(action => action())
    await Promise.all(refreshActions)
    handleCloseSociogramModal()
  }

  return (
    <div
      className={styles.button_wrapper}
      data-test='create-sociogram-container'
    >
      <ButtonComponent
        onClick={() => handleOpenSociogramModal()}
        colorType='primary'
        size='medium'
        buttonText={t('activationSociogramMessage')}
        block={false}
        bold={false}
        disabled={disabled}
      />
      <ModalComponent
        stateModal={showCreateSociogramModal}
        modalTitle={t('activeSociogramModal.modalTitle')}
        modalDescription={
          <div className={styles.modal_description_wrapper}>
            {t('activeSociogramModal.description')}
          </div>
        }
        onClickConfirm={() => handleClickCreateSociogram()}
        onClickCloseModal={() => handleCloseSociogramModal()}
        loading={loadingResponseCreationSociogram}
        dataTest='create-sociogram'
      />
    </div>
  )
}

export default CreateSociogramModal
